import type { LandingTab } from '../types/landing.types';

export const LANDING_SECTION_TITLE = 'Controle da Landing Page';
export const LANDING_SECTION_SUBTITLE = 'Controle os dados que aparecerão na landing page do Practium';

export const LANDING_CTA_TITLES: Record<LandingTab, string> = {
	plans: 'Visualize as alterações na landing page',
	testimonials: 'Crie para landing page depoimentos personalizados',
};

export const LANDING_CTA_SUBTITLES: Record<LandingTab, string> = {
	plans: 'Com apenas um clique você verá como ficará os planos do Practium',
	testimonials: 'Com isso as pessoas que visitarem a landing page terão mais confiança',
};

export const LANDING_CTA_BUTTON: Record<LandingTab, string> = {
	plans: 'Visualizar',
	testimonials: 'Adicionar',
};

export const LANDING_PIE_TITLE = 'Distribuição de Assinantes';
export const LANDING_PIE_SUBTITLE = 'Distribuição de assinantes dos planos do Practium';

export const LANDING_TAB_LABELS: Record<LandingTab, string> = {
	plans: 'Planos',
	testimonials: 'Depoimentos',
};
